<script>
	import {docs} from "./store.js";
	import {push} from "svelte-spa-router";
	let url = "https://vps-1858514-x.dattaweb.com/arteflordepiel";
	let url2 = "http://200.58.99.151:5984/arteflordepiel"
	let rep;
	export async function conectar(){
		rep = PouchDB.sync("db",url2,{
			auth:{
				username: "arte",
				password: "flor"
			},
			live: true,
			retry: true
		})
			.on("change",async function (info){
				console.log(info);
				await actualizarDocs();
			})
			.on("error",function(err){
				console.log("replication error:", err)
			})
	}
	export async function actualizarDocs(){
		const allDocs = await db.allDocs({
			include_docs: true
		})
		$docs = allDocs.rows.map(row => row.doc);
	}
	
</script>
